import { ONBOARDING_PAGE } from 'global/routes';

export const LKFOnboardingRoutes = {
  CITIZEN_HUB: `${ONBOARDING_PAGE}/citizen-hub`,
  SCIENCE_VILLAGE: `${ONBOARDING_PAGE}/science-village`,
  XPLORION: `${ONBOARDING_PAGE}/xplorion`,
  YOUR_INFO: `${ONBOARDING_PAGE}/your-info`,
};
